import { createContext } from 'react';

const bankContext = createContext();

export default bankContext;